import { Badge, Badges } from '@rdss/client'
import { Component, Host, h, Prop } from '@stencil/core'

/**
 * Component to host all submitted badges from the backend.
 *
 * @example
 *
 * const badges: Badges = [
 *    {
 *      type: 'two-lines',
 *      lines: [
 *          'LINE 1',
 *          'LINE 2',
 *      ],
 *    },
 * ]
 * <wf-badges badges={badges} />
 */
@Component({
    tag: 'wf-badges',
    styleUrl: 'wf-badges.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfBadges {
    /**
     * The badges provided by the backend.
     */
     @Prop() badges!: Badges

     /**
      * Returns the class for the badge generated from class attribute or type if missing.
      */
     private getBadgeClass(badge: Badge): string {
         return badge.class ?? badge.type
     }

     /**
      * Renders the component.
      *
      * @returns {JSX.Element} - The rendered component.
      */
     render() {
         return (
             <Host>
                 <div class="badge-list">
                     {Object.values(this.badges ?? {})?.map((badge, index) => (
                         <div class="badge-item">
                             <wf-badge key={index} class={{ [`badge-type--${this.getBadgeClass(badge)}`]: true }} label={badge} />
                         </div>
                     ))}
                 </div>
             </Host>
         )
     }

}
